import { AxiosInstance } from 'axios';
import { SchedulesRepository } from '@/model/repository/manager/schedules/SchedulesRepository';

export default (Repository: AxiosInstance) =>
  (resource: string): SchedulesRepository => ({
    index(payload) {
      return Repository.get(`${resource}`, { params: payload });
    },
  });
